<div
  class="bm-user-block"
  [ngClass]="{ loggedIn: user, 'bm-user-block--text-btns-mode': !boxBtnMode }"
>
  <app-your-tickets
    *ngIf="user"
    [boxBtnMode]="boxBtnMode"
    [opened]="activedMenuItem === ActiveMenuItemEnum.TICKETS"
    (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.TICKETS)"
  ></app-your-tickets>
  <app-your-coupons
    *ngIf="user"
    [boxBtnMode]="boxBtnMode"
    [opened]="activedMenuItem === ActiveMenuItemEnum.DEALS"
    (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.DEALS)"
  ></app-your-coupons>
  <app-trip-plan [boxBtnMode]="boxBtnMode"></app-trip-plan>
  <app-auth
    [boxBtnMode]="boxBtnMode"
    [opened]="activedMenuItem === ActiveMenuItemEnum.AUTH"
    (toggleMenu)="toggleMenuHandler($event, ActiveMenuItemEnum.AUTH)"
  ></app-auth>
  <div class="logout-container" *ngIf="!!user">
    <button class="bm-button bm-link" (click)="logout()">
      {{ 'logout' | translate }}
    </button>
  </div>
  <div
    class="recommended-container"
    *ngIf="
      recommended &&
      recommended.length > 0 &&
      !user &&
      !appConfig.settings.is_white_label
    "
  >
    <div class="recommended-title">
      {{ 'recommended-destinations' | translate }}
    </div>
    <div class="recommended-list">
      <div
        class="item"
        *ngFor="let slideItem of recommended"
        [ngStyle]="getSlideImage(slideItem)"
      >
        <div class="about">
          <div class="title">{{ slideItem.title }}</div>
          <!--          <div class="stats" [translate]="'beacons-with-counts'" [translateParams]="{value: slideItem.cluster}"></div>-->
        </div>
      </div>
    </div>
  </div>
</div>
